var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ruler",staticStyle:{"white-space":"nowrap"}},_vm._l((_vm.items),function(item,i){return _c('span',{key:i,staticClass:"pink"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }